/**
 * The user guides of the clinic panel — one PDF per role, Persian only,
 * shipped with the frontend itself (public/manuals) so Dev and production
 * always carry the same files and production serves them from its own host.
 * A new edition arrives as a new file name (the version is in it), so no
 * browser keeps an old guide under a new one's name. Update this list with
 * the file.
 */

export interface Manual {
  id: 'manager' | 'therapist' | 'reception' | 'family-connection' | 'packages';
  /** Served from the app's own origin. */
  href: string;
  /** The name the download is saved under — the author's own. */
  downloadName: string;
  title: string;
  audience: string;
  description: string;
  version: string;
  /** As printed on the cover. */
  date: string;
}

export const MANUALS: readonly Manual[] = [
  {
    id: 'manager',
    href: '/manuals/manager-guide-v0.4.pdf',
    downloadName: 'راهنمای-مدیر-مرکز-V0.4.pdf',
    title: 'راهنمای مدیر مرکز',
    audience: 'مدیر مرکز و مسئول راه‌اندازی',
    description:
      'راه‌اندازی مرکز در زویار، ساختن حساب همکاران و نقش‌ها، تنظیم خدمات، اتاق‌ها، ساعت‌های کاری و بسته‌ها، و خواندن داشبورد مدیریتی.',
    version: 'V0.4',
    date: 'آبان ۱۴۰۵',
  },
  {
    id: 'therapist',
    href: '/manuals/therapist-guide-v0.4.pdf',
    downloadName: 'راهنمای-درمانگر-V0.4.pdf',
    title: 'راهنمای درمانگر',
    audience: 'درمانگران',
    description:
      'دیدن برنامهٔ روز، شروع و ثبت جلسه، نوشتن گزارش، معارفه، ارزیابی، ابزارهای بالینی، برنامهٔ درمان و تکلیف خانگی، جلسهٔ گروهی و جلسهٔ آنلاین.',
    version: 'V0.4',
    date: 'آبان ۱۴۰۵',
  },
  {
    id: 'reception',
    href: '/manuals/reception-guide-v0.4.pdf',
    downloadName: 'راهنمای-پذیرش-V0.4.pdf',
    title: 'راهنمای پذیرش',
    audience: 'پذیرش، منشی و حسابداری مرکز',
    description:
      'ثبت مراجع، نوبت‌دهی در تقویم، جلسهٔ گروهی، پرداخت و هزینه‌های اضافه، بسته‌ها، ارتباط با خانواده، پیگیری‌ها و پایان درمان.',
    version: 'V0.4',
    date: 'آبان ۱۴۰۵',
  },
  {
    id: 'family-connection',
    href: '/manuals/family-connection-guide-v0.4.pdf',
    downloadName: 'راهنمای-جامع-اتصال-خانواده-و-کلینیک-V0.4.pdf',
    title: 'راهنمای جامع اتصال اپ خانواده و کلینیک',
    audience: 'مدیر مرکز، پذیرش، درمانگر و پشتیبانی زویار',
    description:
      'همهٔ مسیرهای اتصال پروندهٔ مراجع در کلینیک به حساب خانواده در اپ زویار: دعوت از طرف کلینیک، درخواست از طرف خانواده، خانواده‌ای که هنوز پرونده ندارد و از «پیگیری‌ها» دنبال می‌شود، کار مشترک بعد از اتصال (جلسه‌ها، تکلیف خانگی، پاسخ خانواده، نظرسنجی) و پایان دادن به اتصال.',
    version: 'V0.4',
    date: 'آبان ۱۴۰۵',
  },
  {
    id: 'packages',
    href: '/manuals/packages-guide-v0.4.pdf',
    downloadName: 'راهنمای-بسته‌ها-و-پرداخت-بسته-V0.4.pdf',
    title: 'راهنمای بسته‌ها و پرداخت بسته',
    audience: 'مدیر مرکز، پذیرش و حسابداری',
    description:
      'همهٔ حالت‌های «بسته» گام‌به‌گام: قالب‌های ثابتی که مدیر می‌سازد، بستهٔ اختصاصی پس از ارزیابی، بستهٔ دستی از پرونده، قیمت و تخفیف، دریافت پول یک‌جا یا جلسه‌به‌جلسه، نوبت‌دهی، تغییر بسته و پایان آن.',
    version: 'V0.4',
    date: 'آبان ۱۴۰۵',
  },
];
